// import { render } from '@testing-library/react';
import './css/App.css'
import React, { useEffect, useState, useRef } from 'react';
import {
  RenderAfterNavermapsLoaded,
  NaverMap,
  Polygon,
  Circle
} from 'react-naver-maps';
import MapUI from './contents/MapUI';
import Loading from './component/Loading';

export default function NaverAPI({ setShow }) {
  const [mapData, setMapData] = useState([]);
  const [gradeTextData, setGradeTextData] = useState([]);
  const [sliderValue, setSliderValue] = useState(mapData.length);
  const [areaValue, setAreaValue] = useState('');
  const [itemData, setItemData] = useState([]);
  const [modalPolygonPath, setModalPolygonPath] = useState([]);
  const [analData, setAnalData] = useState([]);
  const [analViewData, setAnalViewData] = useState([]);
  const [markerData, setMarkerData] = useState([]);
  const [analDetailData, setAnalDetailData] = useState([]);
  const [rangeChangeData, setRangeChangeData] = useState([]);
  const [heatData, setHeatData] = useState([]);  
  const [sectorData, setSectorData] = useState([]);
  const [analysisData, setAnalysisData] = useState([]);

  const [clusterId, setClusterId] = useState('');
  const [center, setCenter] = useState({ lat: 37.5662952, lng: 126.9779451 });
  const [currentBase, setCurrentBase] = useState('상점수')
  const [color, setColor] = useState('red');
  const [searchType, setSearchType] = useState('num');
  const [searchGubun, setSearcGubun] = useState('');
  const [searchItem, setSearcItem] = useState('');
  const [areaInfo, setAreaInfo] = useState('');
  const [areaSizeInfo, setAreaSizeInfo] = useState('');
  const [colorStyles, setColorStyles] = useState('linear-gradient(to top, #ffd75d,#e87f35, #cd1103)');

  const [modalPolygonArea, setModalPolygonArea] = useState();
  const [navermapData, setNavermapData] = useState()

  const [selectedPolygon, setSelectedPolygon] = useState(null);
  const [modalPolygonCenter, setModalPolygonCenter] = useState(null);
  const mapRef = useRef(null);
  const [tooltip, setTooltip] = useState(null);
  const [infoWindow, setInfoWindow] = useState(null);

  const [reportBusiness, setReportBusiness] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isExpanded, setIsExpanded] = useState(false);
  const [clusterInfo, setClusterInfo] = useState(false);

  const [rangeMin, setRangeMin] = useState(0);
  const [rangeMax, setRangeMax] = useState(1640);
  const [searchMin, setSearchMin] = useState(0);
  const [searchMax, setSearchMax] = useState(1640);

  // component 관리하는 state
  const [state, setState] = useState({
    menu: false,
    list: false,
    // listArray:[],
    gu: [],
    select: false,
    toggle: false,
    cluster: false,
    range: false,
    search: false,
    // modal: false,
    // modalPolygon: false,
    // modalSelect: false,
    containerShow: false,
    containerShow2: false,
    containerShow3: false
  });

  const [modal, setModal] = useState({
    modalPolygon: false,
    modalSelect: false
  })

  //window.naver에 값이 들어올 때 까지 1초 반복
  const checkNaverMap = async () => {
    while (!window.naver) {
      await new Promise((resolve) => setTimeout(resolve, 1000));
    }
    setNavermapData(window.naver);
  };

  useEffect(() => {
    checkNaverMap();
  }, []);

  useEffect(() => {
    setLoading(true);

    let data = {}
    data['color'] = color;
    data['cluster_id'] = '';
    data['search_type'] = searchType;
    data['search_anal'] = analData;
    data['search_anal_detail'] = analDetailData;
    data['area'] = areaValue;
    data['range'] = rangeChangeData;
    data['min'] = searchMin;
    data['max'] = searchMax;

    (async () => {
      await fetch("/api/getClusterEdges", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({ data })
      })
        .then(res => {
          return res.json()
        })
        .then(data => {
          if (data.features.length == 0) {
            alert('조회 된 클러스터가 없습니다.');
            setMapData([]);
            setGradeTextData([]);
            setState({ ...state, cluster: false })
          } else {
            setState({ ...state, cluster: true })
            setMapData(data.features);
            setGradeTextData(data.grade);
            handleColorList();
            setState({...state, containerShow: false, containerShow2: false, containerShow3: false})
          }
          setLoading(false);
        })
        .catch(error => console.log(error));
    })()
  }, [color, searchType, analData, analDetailData, areaValue, rangeChangeData, searchMin, searchMax]);

  useEffect(() => {
    let data = {}
    data['type'] = 'sector';

    fetch("api/getCommonCode", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ data })
    })
      .then(res => {
        return res.json()
      })
      .then(data => {
        setSectorData(data.sector);
      })
      .catch(error => console.log(error))
  }, [])

	useEffect(() => {
		let data = { type: 'business' }

		fetch("api/getCommonCode", {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
			},
			body: JSON.stringify({ data })
		})
			.then(res => {
				return res.json()
			})
			.then(data => {
				Object.values(data).filter(item => {
					return setAnalysisData(item)
				})
			})
			.catch(error => console.log(error))
	}, [])


  const handleColorChange = (color) => {
    setColor(color);
    setState({...state, containerShow: false, containerShow2: false, containerShow3: false})
  }

  const handleRangeChange = () => {
    setSearchMin(rangeMin);
    setSearchMax(rangeMax);
  }

  const handleColorList = () => {
    switch (color) {
      case 'red':
        setColorStyles('linear-gradient(to top, #ffd75d,#e87f35, #cd1103)');
        break;
      case 'green':
        setColorStyles('linear-gradient(to top, #eaf5c0,#88a46a, #0e4000)');
        break;
      case 'blue':
        setColorStyles('linear-gradient(to top, #cccccc, #7190a4, #004574)');
        break;
      case 'purple':
        setColorStyles('linear-gradient(to top, #cccccc, #80719d, #230064)');
        break;
      case 'indigo':
        setColorStyles('linear-gradient(to top, #cccccc, #7174a0, #00076a)');
        break;
      case 'brown':
        setColorStyles('linear-gradient(to top, #fdf3d6, #c19d76, #783300)');
        break;
      default:
        break;
    }
  }

  const handleSearchData = (data) => {
    // 기준
    //setSearchType(data.search_type);
    if (data.search_type == "num") {        
      setCurrentBase('상점수');
    } else if (data.search_type == "omega") {
      setCurrentBase('회복탄력성');
    } else if (data.search_type == "pay") {
      setCurrentBase('매출액(백만원)');
    }

    if (data.min != '' && data.max == '') {
      //setSearchMin(data.min);
      setRangeMin(data.min);

      if (data.search_type == "num") {   
        //setSearchMax(1640);
        setRangeMax(1640);
      } else if (data.search_type == "omega") {
        //setSearchMax(50);
        setRangeMax(50);
      } else if (data.search_type == "pay") {
        //setSearchMax(84000);
        setRangeMax(84000);
      }
    }
    if (data.max != '' && data.min == '') {
      //setSearchMin(0);
      setRangeMin(0);
      //setSearchMax(data.max);
      setRangeMax(data.max);
    }
    if (data.min == '' && data.max == '') {
      //setSearchMin(0);
      setRangeMin(0);
      if (data.search_type == "num") {   
        //setSearchMax(1640);
        setRangeMax(1640);
      } else if (data.search_type == "omega") {
        //setSearchMax(50);
        setRangeMax(50);
      } else if (data.search_type == "pay") {
        //setSearchMax(84000);
        setRangeMax(84000);
      }
    }
    if (data.min != '' && data.max != '') {
      setRangeMin(data.min);
      setRangeMax(data.max);
    }

    // 범위
    if (data.range.length != 0) {
      setRangeChangeData([data.range[0], data.range[1]]);

      let gubun = '';
      if (data.range[0] == 'high') {
        gubun = '상위';
      } else {
        gubun = '하위';
      }
      
      setSearcGubun(gubun);
      setSearcItem(data.range[1]);
    };

    // 구역
    if (data.area != '') {
      setState({ ...state, gu: data.area })
      setAreaValue(data.area);
    }

    //
    if (data.search_anal.length > 0) {
      setAnalViewData(data.search_anal_name);
    }
  }

  const handleReangeChange = () => {

    let gubun = '';
    if (searchGubun == '상위') {
      gubun = 'high';
    } else {
      gubun = 'low';
    }

    setRangeChangeData([gubun, searchItem]);
  }

  const handleSliderChange = (event) => {
    setSliderValue(event.target.value);
  };

  const getRangeIndex = (sliderValue, count) => {
    const range = 523 / count;
    const index = Math.floor(sliderValue / range);
    return index >= count ? count - 1 : index;
  }

  const handleAreaSelect = (data, point) => {
    setAreaValue(data);

    if (point != "") {
      if (mapRef.current) {
        const map = mapRef.current.map;

        let jsonString = point.replace(/(\w+)\s*:/g, '"$1":'); // add quotes around property names
        let centerObj = JSON.parse(jsonString);

        map.setCenter(centerObj);
        map.setZoom(13);
      }
    } else {
      const map = mapRef.current.map;
      map.setCenter(center);
      map.setZoom(12);
    }
  };

  const handleTabSelect = (flag) => {
    const map = mapRef.current.map;
    if (flag) {
      const heatmap = new navermapData.maps.visualization.HeatMap({
        map: map,
        data: heatData,
        opacity: 0.3,
        radius: 15,
      });
      map.setZoom(12);
    } else {
      if (map.HeatMapLayerLayer != null) {
        map.HeatMapLayerLayer.setMap(null);
      }
      //map.setZoom(13);
    }
  };

  const removeHeatMap = () => {
    const map = mapRef.current.map;
    if (map.HeatMapLayerLayer != null) {
      map.HeatMapLayerLayer.setMap(null);
    }
  };

  const filteredMapData = mapData.filter((item, idx) => {
    if (sliderValue == 0) {
      return true;
    } else {
      return item.properties.grade >= sliderValue;
    }
  });

  const filteredMarkerData = markerData.filter((item, idx) => {
    if (analData.length == 0) {
      return true;
    } else {
      return analData.includes(item.comm_code);
    }
  });

  const searchItemDataByCluster = (id, code, detail) => {
    let data = {}
    data['cluster_id'] = id;
    data['code'] = code;
    data['detail'] = detail;

    fetch("/api/getItem", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ data })
    })
      .then(res => {
        return res.json()
      })
      .then(data => {
        setIsExpanded(true);
        setItemData(data);
        setClusterId(id);
        setReportBusiness(true);
        setState({ ...state, toggle: true, containerShow: false, menu: false, toggleGu: false, range: false })
        setLoading(false);
      })
      .catch(error => console.log(error))
  }

  const searchClusterData = (id, polygonCenter, map, newBounds) => {
    let data = {}
    data['cluster_id'] = id;

    fetch("/api/getClusterData", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ data })
    })
      .then(res => {
        return res.json()
      })
      .then(data => {
        //polygon의 center 좌표
        let lat = polygonCenter.y;
        let lng = polygonCenter.x;

        setModalPolygonCenter({ lat: lat, lng: lng });
        setMarkerData(data.marker);
        setHeatData(data.heat);

        if (data.area > 3.2) {
          setModalPolygonArea(13);
        } else if (data.area > 1.1) {
          setModalPolygonArea(14);
        } else {
          setModalPolygonArea(15);
        }

        map.fitBounds(newBounds);
        if (data.area > 3.2) {
          map.setZoom(15);
        } else if (data.area < 0.4) {
          map.setZoom(17);
        } else {
          map.setZoom(16);
        }

        setClusterInfo(true);
        if (data.gu != "") {
          setAreaInfo(data.gu + " km<sup _ngcontent-unm-c151='' className='sup'>2</sup> 내외");
        }

        if (data.area != "") {
          setAreaSizeInfo(data.area + " km<sup _ngcontent-unm-c151='' className='sup'>2</sup>")
        }
      })
      .catch(error => console.log(error))
  }

  const searchClusterByText = (text) => {
    setLoading(true);
    let data = {}
    data['text'] = text;
    data['color'] = color;

    fetch("/api/getTextSearch", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ data })
    })
      .then(res => {
        return res.json()
      })
      .then(res => {
        if (res.data.features.length == 0) {
          alert('조회 된 클러스터가 없습니다.');
          setMapData([]);
          setGradeTextData([]);
          setState({ ...state, cluster: false })
        } else {
          setState({ ...state, cluster: true })
          setMapData(res.data.features);
          setGradeTextData(res.data.grade);
          handleColorList();
          handleSearchData(res.search.data);
        }
        setLoading(false);
      })
      .catch(error => console.log(error))
  }

  const searchClusterByMul = (data) => {
    setLoading(true);

    data['color'] = color;
    
    fetch("/api/getMultiSearch", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ data })
    })
      .then(res => {
        return res.json()
      })
      .then(res => {
        if (res.features.length == 0) {
          alert('조회 된 클러스터가 없습니다.');
          setMapData([]);
          setGradeTextData([]);
          setState({ ...state, cluster: false })
        } else {
          setState({ ...state, cluster: true })
          setMapData(res.features);
          setGradeTextData(res.grade);
          //handleColorList();
          //handleSearchData(res.search.data);
        }
        setLoading(false);
      })
      .catch(error => console.log(error))
  }

  //polygon click event
  const polygonClicked = (e, id) => {
    setLoading(true);
    setState({ ...state, toggle: false, menu: false, toggleGu: false, range: false, list: false, search: false });

    const map = e.overlay.getMap();
    removeHeatMap();

    const polygonBounds = e.overlay.getBounds();
    const polygonCenter = e.overlay.getBounds().getCenter();

    let northEast = ({ x: polygonBounds._max.x + 0.005, y: polygonBounds._max.y })
    let southWest = ({ x: polygonBounds._min.x + 0.005, y: polygonBounds._min.y })

    let newBounds = new navermapData.maps.LatLngBounds(northEast, southWest);
    searchItemDataByCluster(id, '', '');
    setModalPolygonPath(e.overlay.getPath().getArray());
    searchClusterData(id, polygonCenter, map, newBounds);
    setSelectedPolygon(id);
  }

  const polygonMouseOn = (e, select) => {
    if (selectedPolygon === null) {
      e.overlay.setOptions({ strokeOpacity: '1', strokeColor: 'black', strokeWeight: '3', fillOpacity: '0.7' });
    }
    else if (select === selectedPolygon) {
      e.overlay.setOptions({ strokeOpacity: '1', strokeColor: 'black', strokeWeight: '3' });
    } else {
      e.overlay.setOptions({ strokeOpacity: '1', strokeColor: 'black', strokeWeight: '3', fillOpacity: '0.7' });
    }
  }

  const polygonMouseOut = (e, select) => {
    if (selectedPolygon === null) {
      e.overlay.setOptions({ strokeOpacity: '0.5', strokeColor: 'red', strokeWeight: '1', fillOpacity: '0.7' });
    }
    else if (select === selectedPolygon) {
      e.overlay.setOptions({ strokeOpacity: '1', strokeColor: 'black', strokeWeight: '3' });
    } else {
      e.overlay.setOptions({ strokeOpacity: '0.2', strokeColor: 'red', strokeWeight: '1', fillOpacity: '0.2' });
    }
  }

  const handleResetClick = () => {
    if (mapRef.current) {
      const map = mapRef.current.map;
      map.setCenter(center);
      map.setZoom(12);
      setReportBusiness(false);
      setSelectedPolygon(null);
      setState({ ...state, toggle: false, menu: false, toggleGu: false, range: false, gu: [], list: false, search: false })

      if (infoWindow) {
        infoWindow.close();
        setInfoWindow(null);
      }
    }
  }

  const handleDetailClick = () => {
    setState({
      ...state,
      toggle: false,
      containerShow: false,
    })
    setModal({
      ...modal,
      modal: false,
      modalPolygon: true
    })
  }

  const handleMainClick = () => {
    setState({ ...state, toggle: false, menu: false, toggleGu: false, range: false, list: false, search: false });

    const map = mapRef.current.map;
    map.setCenter(center);
    map.setZoom(12);

    setMarkerData([]);
    setClusterInfo(false);
    setSelectedPolygon(null);

  }

  const UIProps = {
    state,
    setState,
    modal,
    setModal,
    mapData,
    sliderValue,
    setSliderValue,
    handleSliderChange,
    getRangeIndex,
    color,
    setColor,
    handleColorChange,
    handleAreaSelect,
    itemData,
    setShow,
    handleResetClick,
    setLoading,
    reportBusiness,
    setIsExpanded,
    currentBase,
    setCurrentBase,
    searchType,
    setSearchType,
    searchGubun,
    setSearcGubun,
    searchItem,
    setSearcItem,
    modalPolygonCenter,
    modalPolygonPath,
    selectedPolygon,
    navermapData,
    modalPolygonArea,
    setAnalData,
    setAnalDetailData,
    analData,
    analDetailData,
    areaInfo,
    gradeTextData,
    setMarkerData,
    setClusterInfo,
    clusterInfo,
    handleReangeChange,
    rangeChangeData,
    setRangeChangeData,
    colorStyles,
    setRangeMin,
    setRangeMax,
    rangeMin,
    rangeMax,
    handleRangeChange,
    setSearchMin,
    setSearchMax,
    searchMin,
    searchMax,
    handleTabSelect,
    removeHeatMap,
    searchClusterByText,
    analViewData, 
    setAnalViewData,
    sectorData,
    analysisData,
    searchClusterByMul
  }

  const setCircleSize = (idx) => {
    let size = 10;
    if (idx == 0) {
      size = 130;
    } else if (idx == 1) {
      size = 120;
    } else if (idx == 2) {
      size = 110;
    } else if (idx == 3) {
      size = 100;
    } else if (idx == 4) {
      size = 90;
    } else if (idx == 5) {
      size = 80;
    } else if (idx == 6) {
      size = 70;
    } else if (idx == 7) {
      size = 60;
    } else if (idx == 8) {
      size = 50;
    } else if (idx == 9) {
      size = 40;
    }

    return size;
  }

  const setCircleColor = (code) => {
    let color = '';
    if (code == 'D') {
      color = '#FF0000';
    } else if (code == 'F') {
      color = '#FFA500';
    } else if (code == 'L') {
      color = '#FFFF00';
    } else if (code == 'N') {
      color = '#008000';
    } else if (code == 'O') {
      color = '#0000FF';
    } else if (code == 'P') {
      color = '#000080';
    } else if (code == 'Q') {
      color = '#800080';
    } else if (code == 'R') {
      color = '#000000';
    } else if (code == 'S') {
      color = '#A52A2A';
    }

    return color;
  }

  return (
    <>
      <RenderAfterNavermapsLoaded
        ncpClientId='3h8t4dtc8b'
        error={<p>Maps Load Error</p>}
        submodules={['visualization']}
      >
        <NaverMap
          className={`my-map ${isExpanded ? "expanded" : ""}`}
          mapDivId={"maps-getting-started-uncontrolled"}
          style={{ width: '100%', height: '100vh', borderTop: 'transparent' }}
          center={center}
          zoom={12}
          naverRef={(ref) => {
            mapRef.current = ref;
          }}
        >
          {markerData.length > 0 &&
            <div className={`colorNotice`}>
              <ul>
                <li><span />소매</li>
                <li><span />생활서비스</li>
                <li><span />부동산</li>
                <li><span />관광·여가·오락</li>
                <li><span />숙박</li>
                <li><span />스포츠</li>
                <li><span />음식</li>
                <li><span />학문·교육</li>
                <li><span />의료</li>
              </ul>
            </div>
          }
          {filteredMapData.map((item, idx) => (
            <Polygon
              key={idx}
              fillColor={item.geometry.fillColor}
              id={item.properties.cluster_id}
              fillOpacity={selectedPolygon === null ? 0.7 : selectedPolygon === item.properties.cluster_id ? 0.4 : 0.2}
              strokeOpacity={selectedPolygon === null ? 0.5 : selectedPolygon === item.properties.cluster_id ? 0.5 : 0.2}
              strokeColor={selectedPolygon === null ? 'red' : selectedPolygon === item.properties.cluster_id ? 'black' : 'red'}
              strokeWeight={selectedPolygon === null ? 1 : selectedPolygon === item.properties.cluster_id ? 3 : 1}
              paths={item.geometry.coordinates}
              clickable={true}
              onClick={(e) => polygonClicked(e, item.properties.cluster_id)}
              onMouseover={(e) => polygonMouseOn(e, item.properties.cluster_id)}
              onMouseout={(e) => polygonMouseOut(e, item.properties.cluster_id)}
            />
          ))}
          {filteredMarkerData.map((item, idx) => (
            <Circle // Circle을 생성하고 지도에 추가
              key={'anal_' + idx}
              center={{ lat: item.lat, lng: item.lon }} // Circle의 중심 좌표
              radius={setCircleSize(idx)} // Circle의 반지름
              fillColor={setCircleColor(item.comm_code)} // Circle 내부 색상
              fillOpacity={0.6} // Circle 내부 색상의 투명도
              strokeColor={'black'} // Circle 외곽선 색상
              strokeOpacity={0.5} // Circle 외곽선 색상의 투명도
              strokeWeight={1} // Circle 외곽선 두께
            />
          ))}
        </NaverMap>
      </RenderAfterNavermapsLoaded>
      <MapUI {...UIProps} />
      <Loading loading={loading} />
      {clusterInfo &&
        <div className='clusterInfo'>
          [클러스터 정보]
          <br />
          구역 : <span dangerouslySetInnerHTML={{ __html: areaInfo }} />
          <br />
          면적 : <span dangerouslySetInnerHTML={{ __html: areaSizeInfo }} />
          <br />
          <br />
          <div className='more-btn-div'>
            <button className="more-btn" onClick={handleMainClick}>뒤로가기</button>
            <button className="more-btn" onClick={handleDetailClick}>상세보기</button>
          </div>
        </div>
      }
    </>
  );
}